import React from "react";
import { IconFileText, IconExternalLink, IconDownload, IconShieldCheck } from "@tabler/icons-react";
import "./PolicyPage.css";

export default function PolicyPage() {
    const policies = [
        {
            id: 1,
            title: "HR Policy 2025",
            version: "v1.2",
            description: "Current comprehensive guidelines regarding employment, benefits, and workplace conduct.",
            pdfUrl: "/assets/HR Policy (Oct-2025).pdf",
            priority: 1, // Current
            lastUpdated: "Oct 15, 2025"
        },
        {
            id: 2,
            title: "HR Policy 2024 (Nov)",
            version: "v1.1",
            description: "Previous version of the policy manual. Reference only for historical tracking.",
            pdfUrl: "/assets/HR Policy (Nov-2024).pdf",
            priority: 2, // Previous
            lastUpdated: "Nov 02, 2024"
        },
        {
            id: 3,
            title: "HR Policy 2024 (Oct)",
            version: "v1.0",
            description: "Archive policy document. Replaced by version 1.1 in November 2024.",
            pdfUrl: "/assets/HR Policy (oct-2024).pdf",
            priority: 3, // Old
            lastUpdated: "Oct 01, 2024"
        },
    ];

    const handleOpenPdf = (pdfUrl) => {
        window.open(pdfUrl, "_blank");
    };

    return (
        <div className="policy-container">
            {/* Header Section */}
            <div className="policy-header">
                <h1>
                    <IconShieldCheck size={44} stroke={2} color="var(--primary-color)" />
                    Policy Documents
                </h1>
                <p>
                    Access official organization policies, guidelines, and compliance documentation.
                    Ensure you are familiar with the current versions listed below.
                </p>
            </div>

            {/* Cards Grid */}
            <div className="policy-grid">
                {policies.map((policy) => (
                    <div key={policy.id} className="policy-card">
                        {/* Priority/Status Badge */}
                        <div className={`priority-badge priority-${policy.priority}`}>
                            {policy.priority === 1 ? "Active" : policy.priority === 2 ? "Previous" : "Archived"}
                        </div>

                        {/* Icon and Title */}
                        <div className="policy-icon-wrapper">
                            <IconFileText size={32} stroke={1.5} />
                        </div>

                        <div className="mb-2">
                            <span className="badge bg-light text-dark border mb-2" style={{ fontSize: '11px' }}>
                                Version {policy.version}
                            </span>
                        </div>

                        <h3 className="policy-title">{policy.title}</h3>
                        <p className="policy-description">{policy.description}</p>

                        <div className="d-flex align-items-center gap-2 mb-4 text-muted small">
                            <IconCalendar size={14} />
                            Updated: {policy.lastUpdated}
                        </div>

                        {/* Action Component */}
                        <button
                            onClick={() => handleOpenPdf(policy.pdfUrl)}
                            className="view-policy-btn"
                        >
                            <IconExternalLink size={20} />
                            View Document
                        </button>
                    </div>
                ))}
            </div>

            <div className="policy-footer">
                <p>© 2026 Organization HRMS • All documents are confidential and for internal use only.</p>
            </div>
        </div>
    );
}

// Helper icon component since it was missing from imports
function IconCalendar({ size }) {
    return (
        <svg
            xmlns="http://www.w3.org/2000/svg"
            width={size}
            height={size}
            viewBox="0 0 24 24"
            fill="none"
            stroke="currentColor"
            strokeWidth="2"
            strokeLinecap="round"
            strokeLinejoin="round"
        >
            <rect x="3" y="4" width="18" height="18" rx="2" ry="2"></rect>
            <line x1="16" y1="2" x2="16" y2="6"></line>
            <line x1="8" y1="2" x2="8" y2="6"></line>
            <line x1="3" y1="10" x2="21" y2="10"></line>
        </svg>
    );
}
